import dayjs from 'dayjs';

import { FetchRecruitmentsResponseType } from './useSearchRecruitments';

export interface RecruitmentsDataType {
  key: React.Key;
  uuid: string;
  candidateId: string;
  candidate: string;
  'project.client.name': string;
  clientId: string;
  projectId: string;
  'project.name': string;
  'project.priority': string;
  'status.name': string;
  responsible: string;
  createdDate: string;
  lastModifiedDate: string;
  actionRequired: boolean;
  perfectMatch: boolean;
}

export const useRecruitmentsTableDataSource = (
  data: FetchRecruitmentsResponseType | undefined
): RecruitmentsDataType[] => {
  if (!data) {
    return [];
  }

  const dataToMap = data?.results;

  return dataToMap.map((element) => {
    return {
      key: element.uuid,
      uuid: element.uuid,
      candidateId: element.candidate.uuid,
      candidate: `${element.candidate?.lastName ?? ''} ${element.candidate?.firstName ?? ''}`,
      clientId: element.project.client.uuid,
      'project.client.name': element.project.client.name,
      projectId: element.project.uuid,
      'project.name': element.project.name,
      'project.priority': element.project.priority,
      'status.name': element.status.name,
      responsible: `${element.responsible?.lastName ?? ''} ${element.responsible?.firstName ?? ''}`,
      createdDate: dayjs.unix(element.createdDate).format('DD-MM-YYYY'),
      lastModifiedDate: dayjs.unix(element.lastModifiedDate).format('DD-MM-YYYY'),
      actionRequired: element.status.actionRequired,
      salaryDescription: element.candidate.expectedSalary,
      recommendedBy: element.candidate.recommendedBy,
      perfectMatch: element.perfectMatch
    };
  });
};
